import React from "react";
import GlobalMetricCards from "../../../../global/GlobalMetricCards";

function formatDate(value) {
  if (!value || value === "—") return "—";
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return String(value);
  }
}

export default function MyMembershipsDashboardSection({ dashboard, loading }) {
  const d = dashboard || {};

  const items = [
    {
      key: "active",
      label: "Active Membership",
      value: d.active_membership ?? "—",
      tone: "teal",
    },
    {
      key: "expiry",
      label: "Membership Expiry Date",
      value: formatDate(d.membership_expiry_date),
      tone: "blue",
    },
    {
      key: "days",
      label: "Days Remaining",
      value: d.days_remaining ?? 0,
      tone: "mint",
    },
    {
      key: "total",
      label: "Total Memberships",
      value: d.total_memberships ?? 0,
      tone: "purple",
    },
    {
      key: "pending",
      label: "Pending Renewals",
      value: d.pending_renewals ?? 0,
      tone: "coral",
    },
    {
      key: "status",
      label: "Membership Status",
      value: d.membership_status ?? "—",
      tone: "slate",
    },
  ];

  return (
    <section className="user-builder-panel" aria-label="Membership dashboard">
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Membership overview</h3>
        <p className="user-builder-panel__hint">
          Snapshot by membership plan. Renewals on the same plan count once;
          stats update when you move to a different plan.
        </p>
      </div>
      <GlobalMetricCards
        items={items}
        loading={loading}
        skeletonCount={6}
        gridClassName="mm-metrics-grid"
        ariaLabel="My memberships dashboard metrics"
      />
    </section>
  );
}
